import add from './add.svg';
import arrowDown from './arrow-down.svg';
import arrowLeft from './arrow-left.svg';
import arrowRight from './arrow-right.svg';
import arrowUp from './arrow-up.svg';
import artist from './artist.svg';
import avatarUpload from './avatar-upload.svg';
import bandcamp from './bandcamp.svg';
import bellHeart from './bell-heart.svg';
import catalog from './catalog.svg';
import chain_base from './chain-base.svg';
import chain_ethereum from './chain-ethereum.svg';
import chain_optimism from './chain-optimism.svg';
import chain_polygon from './chain-polygon.svg';
import chain_zora from './chain-zora.svg';
import channels from './channels.svg';
import check from './check.svg';
import checked from './checked.svg';
import close from './close.svg';
import coin from './coin.svg';
import connected from './connected.svg';
import copy from './copy.svg';
import creditCard from './credit-card.svg';
import crowd from './crowd.svg';
import curatorAdd from './curator-add.svg';
import curators from './curators.svg';
import developer from './developer.svg';
import diamondSuccess from './diamond-success.svg';
import diamond from './diamond.svg';
import discord from './discord.svg';
import dotsMenu from './dots-menu.svg';
import edit from './edit.svg';
import emptyFace from './empty-face.svg';
import ethereum from './ethereum.svg';
import exchange from './exchange.svg';
import excited from './excited.svg';
import expand from './expand.svg';
import externalLink from './external-link.svg';
import externalPlatform from './external-platform.svg';
import facebook from './facebook.svg';
import feedEmpty from './feed-empty.svg';
import feedHides from './feed-hides.svg';
import feedLikes from './feed-likes.svg';
import feedVinyl from './feed-vinyl.svg';
import feedback from './feedback.svg';
import fork from './fork.svg';
import forward from './forward.svg';
import globe from './globe.svg';
import groupHeart from './group-heart.svg';
import group from './group.svg';
import heart from './heart.svg';
import heart_fill from './heart_fill.svg';
import hey from './hey.svg';
import imageUpload from './image-upload.svg';
import info from './info.svg';
import instagram from './instagram.svg';
import itunes from './itunes.svg';
import key from './key.svg';
import library from './library.svg';
import lock from './lock.svg';
import login from './login.svg';
import logoutModal from './logout-modal.svg';
import minus from './minus.svg';
import mute from './mute.svg';
import nftInfo from './nft-info.svg';
import nftLoading from './nft-loading.svg';
import nftMint from './nft-mint.svg';
import nftOwned from './nft-owned.svg';
import nftUnavailable from './nft-unavailable.svg';
import nftActivity from './nftActivity.svg';
import nina from './nina.svg';
import noizd from './noizd.svg';
import notConnected from './not-connected.svg';
import notificationsEnable from './notifications-enable.svg';
import notifications from './notifications.svg';
import notifications_fill from './notifications_fill.svg';
import owner from './owner.svg';
import palette from './palette.svg';
import pause from './pause.svg';
import personCelebrate from './person_celebrate.svg';
import personSearch from './person_search.svg';
import play from './play.svg';
import playlistAdd from './playlist-add.svg';
import playlistFree from './playlist-free.svg';
import playlistSolo from './playlist-solo.svg';
import podcast from './podcast.svg';
import privateIcon from './private.svg';
import publicIcon from './public.svg';
import queueAdd from './queue-add.svg';
import queue from './queue.svg';
import remove from './remove.svg';
import repeatOne from './repeat-one.svg';
import repeat from './repeat.svg';
import rewind from './rewind.svg';
import search from './search.svg';
import seekBackward15 from './seek-backward-15.svg';
import seekForward15 from './seek-forward-15.svg';
import settings from './settings.svg';
import sharePlaylist from './share-playlist.svg';
import share from './share.svg';
import shuffle from './shuffle.svg';
import signout from './signout.svg';
import sound from './sound.svg';
import soundcloud from './soundcloud.svg';
import spinWow from './spin-wow.svg';
import spotify from './spotify.svg';
import switchArrows from './switch-arrows.svg';
import tidal from './tidal.svg';
import tiktok from './tiktok.svg';
import tip from './tip.svg';
import tooltipArrow from './tooltip-arrow.svg';
import transfer from './transfer.svg';
import twitch from './twitch.svg';
import twitter from './twitter.svg';
import upload from './upload.svg';
import upvote from './upvote.svg';
import upvote_fill from './upvote_fill.svg';
import userMusic from './user-music.svg';
import userSearch from './user-search.svg';
import user from './user.svg';
import vinylSuccess from './vinyl-success.svg';
import vinyl from './vinyl.svg';
import visibilityOff from './visibility-off.svg';
import visibility from './visibility.svg';
import volume from './volume.svg';
import wallet from './wallet.svg';
import walletconnect from './walletconnect.svg';
import warning from './warning.svg';
import warpcast from './warpcast.svg';
import wrongNetwork from './wrong-network.svg';
import youtube from './youtube.svg';
import zora from './zora.svg';

export default {
  add,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  artist,
  avatarUpload,
  bandcamp,
  bellHeart,
  catalog,
  chain_base,
  chain_ethereum,
  chain_optimism,
  chain_polygon,
  chain_zora,
  channels,
  check,
  checked,
  close,
  coin,
  connected,
  copy,
  creditCard,
  crowd,
  curatorAdd,
  curators,
  developer,
  diamond,
  diamondSuccess,
  discord,
  dotsMenu,
  edit,
  emptyFace,
  ethereum,
  exchange,
  excited,
  expand,
  externalLink,
  externalPlatform,
  facebook,
  feedEmpty,
  feedHides,
  feedLikes,
  feedVinyl,
  feedback,
  fork,
  forward,
  heart,
  heart_fill,
  hey,
  imageUpload,
  globe,
  group,
  groupHeart,
  info,
  instagram,
  itunes,
  key,
  library,
  lock,
  login,
  logoutModal,
  minus,
  mute,
  nftLoading,
  nftInfo,
  nftMint,
  nftOwned,
  nftUnavailable,
  nftActivity,
  nina,
  noizd,
  notConnected,
  notificationsEnable,
  notifications,
  notifications_fill,
  owner,
  palette,
  personCelebrate,
  personSearch,
  play,
  playlistAdd,
  playlistFree,
  playlistSolo,
  podcast,
  privateIcon,
  publicIcon,
  pause,
  queue,
  queueAdd,
  remove,
  repeat,
  repeatOne,
  rewind,
  search,
  seekBackward15,
  seekForward15,
  settings,
  share,
  sharePlaylist,
  shuffle,
  sound,
  soundcloud,
  spinWow,
  spotify,
  switchArrows,
  tidal,
  tiktok,
  tooltipArrow,
  tip,
  transfer,
  twitch,
  twitter,
  signout,
  upload,
  upvote,
  upvote_fill,
  userMusic,
  user,
  userSearch,
  vinyl,
  vinylSuccess,
  visibility,
  visibilityOff,
  volume,
  wallet,
  walletconnect,
  warning,
  warpcast,
  wrongNetwork,
  youtube,
  zora,
};
